module.exports = __webpack_public_path__ + "img/81334ae.png";